import { init } from "ityped";
import { isSP } from "../../common/functions/isSP";

export default class FamiliesArchive {
    constructor() {
        this.offscreenCanvasCtx = null;
        this.canvas = [...document.querySelectorAll(".js-families__canvas")];
        this.screenArray = [];
        this.size = {
            baseSize: 500,
            videoWidth: 500 * 3,
            videoHeight: 500 * 5,
        };
        this.run = true;
        this.video = null; //後に初期化
        this.init();
    }

    setOffscreenCanvas() {
        const src = document.querySelector(".js-families_videoref").getAttribute("data-src");
        const video = document.createElement("video");
        video.setAttribute("class", "l-families__video");
        video.muted = true;
        video.playsInline = true;
        video.loop = true;
        video.src = src;
        video.load();
        this.video = video;

        let initialized = false;

        video.addEventListener("canplaythrough", () => {
            if (!initialized) {
                document.querySelector(".js-families").setAttribute("data-loaded", "1");
                //console.log("Video Loaded");
                video.play();
                document.body.appendChild(video);

                const offscreen = new OffscreenCanvas(this.size.videoWidth, this.size.videoHeight);
                const offctx = offscreen.getContext("2d", { willReadFrequently: true });
                const screenArray = [];
                this.offscreenCanvasCtx = offctx;

                this.canvas.forEach((el) => {
                    const obj = {
                        el: el,
                        ctx: el.getContext("2d", { willReadFrequently: true }),
                        x: parseInt(el.getAttribute("data-x")),
                        y: parseInt(el.getAttribute("data-y")),
                    };
                    el.width = this.size.baseSize;
                    el.height = this.size.baseSize;
                    screenArray.push(obj);
                });

                this.screenArray = screenArray;
                this.runRaf();
                initialized = true;
            }
        });
    }

    runRaf() {
        const fps = 80;
        let lastRenderTime = 0;

        const render = (now) => {
            const delta = now - lastRenderTime;

            if (this.offscreenCanvasCtx === null) {
                return;
            }

            //Max 60fpsに指定
            if (1000 / fps < delta) {
                lastRenderTime = now;
                this.offscreenCanvasCtx.drawImage(this.video, 0, 0, this.size.videoWidth, this.size.videoHeight);
                const bitmap = this.offscreenCanvasCtx.getImageData(0, 0, this.size.videoWidth, this.size.videoHeight);

                this.screenArray.forEach((el) => {
                    el.ctx.putImageData(
                        bitmap,
                        el.x * -this.size.baseSize,
                        el.y * -this.size.baseSize,
                        el.x * this.size.baseSize,
                        el.y * this.size.baseSize,
                        this.size.baseSize,
                        this.size.baseSize
                    );
                });
            }

            if (this.run) {
                requestAnimationFrame(render);
            }
        };

        requestAnimationFrame(render);
    }

    init() {
        if (this.canvas.length > 0) {
            this.setOffscreenCanvas();
            this.watchScroll();
            this.mouseHover();
        }
    }

    mouseHover() {
        const items = [...document.querySelectorAll(".js-families__link")];

        items.forEach((item) => {
            const parent = item.parentNode;
            const hoverTxt = parent.querySelector(".js-families__hovertxt");
            let isHover = false;

            const isEndTyped = () => {
                return hoverTxt.textContent.length === hoverTxt.getAttribute("data-txt").length;
            };

            item.addEventListener("mouseenter", () => {
                if (isSP() || isHover || !isEndTyped()) {
                    return;
                }

                parent.setAttribute("data-hover", "1");
                hoverTxt.textContent = "";
                isHover = true;

                init(hoverTxt, {
                    showCursor: false,
                    disableBackTyping: true,
                    startDelay: 0,
                    typeSpeed: 50,
                    strings: [hoverTxt.getAttribute("data-txt")],
                    onFinished: () => {
                        isHover = false;
                    },
                });
            });
            item.addEventListener("mouseleave", () => {
                parent.removeAttribute("data-hover");
            });
        });
    }

    watchScroll() {
        // 監視する対象（data-orderの値順にtargetObjectsに入れています）
        const targetObjects = [...document.querySelectorAll(".js-families")];

        // IntersectionObserverの設定
        const options = {
            threshold: 0,
        };

        // コールバックの受け取り
        const callback = (entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    //console.log(`Families : 交差開始`);
                    this.video.play && this.video.play();
                    this.run = true;
                    this.runRaf();
                } else {
                    //console.log(`Families : 交差終了`);
                    this.video.pause && this.video.pause();
                    this.run = false;
                }
            });
        };

        // IntersectionObserverオブジェクトを作る
        const observerObject = new IntersectionObserver(callback, options);

        // 監視対象の監視を開始する
        targetObjects.forEach((object) => {
            observerObject.observe(object);
        });
    }
}
